import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// import userProfile.css from "user-Profile"
import UserProfile from "../User-Profile/userProfile.css";
import ProfileImage from "../../assets/images/user.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ProfilePage = () => {
  const { id } = useParams(); // Get publisher ID from URL
  const [profileData, setProfileData] = useState({
    account_name: "",
    username: "",
    person_name: "",
    email: "",
    phone_no: "",
    company_name: "",
    address: "",
    country: "",
    status: "",
  });
  const accountId = localStorage.getItem("account_id");
  const navigate = useNavigate();
  // Fetch profile details
  const fetchProfile = async () => {
    if (!accountId) {
      console.error("No account_id found in localStorage");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/pub/getPublisher/${accountId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.status === 200) {
        setProfileData(response.data.data[0]);
      }
    } catch (error) {
        if (error.response?.status === 401) {
            console.error("Unauthorized! Token might be expired.");
            localStorage.removeItem("token");
            navigate("/");
          }
      console.error("Error fetching profile details:", error);
    }
  };

  useEffect(() => {
    fetchProfile();
    console.log(profileData);
  }, [id]);

  return (
    <section className="mainContainer">
      <div className="container mt-4">
        {/* <h2>Profile Details</h2> */}
        {/* <form>
        <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label">Account Name</label>
          <input type="text" className="form-control" value={profileData.account_name} readOnly />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">Username</label>
          <input type="text" className="form-control" value={profileData.username} readOnly />
        </div>
        </div>
        <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label">Person Name</label>
          <input type="text" className="form-control" value={profileData.person_name} readOnly />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">Email</label>
          <input type="email" className="form-control" value={profileData.email} readOnly />
        </div>
        </div>
        <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label">Phone No</label>
          <input type="text" className="form-control" value={profileData.phone_no} readOnly />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">Company Name</label>
          <input type="text" className="form-control" value={profileData.company_name} readOnly />
        </div>
        </div>
        <div className="row">
        <div className="col-md-4 mb-3">
          <label className="form-label">Address</label>
          <input type="text" className="form-control" value={profileData.address} readOnly />
        </div>
        <div className="col-md-4 mb-3">
          <label className="form-label">Country</label>
          <input type="text" className="form-control" value={profileData.country} readOnly />
        </div>
        <div className="col-md-4 mb-3">
          <label className="form-label">Status</label>
          <input type="text" className="form-control" value={profileData.status} readOnly />
        </div>
        </div>
      </form> */}
        <div className="row">
          <div class="col-xxl-12 col-xl-12 col-lg-12">
            <div class="card welcome-profile">
              <div class="card-body">
                <img src={ProfileImage} alt="" />
                <h4>Welcome, {profileData?.account_name}!</h4>
                <p>
                    Unlock the full revenue potential of your website with AdChronix.
                </p>
                <ul>
                  <li>verified account</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-xxl-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">Profile Information</h4>
              </div>
              <div class="card-body">
                <form class="row">
                  <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                    <div class="user-info">
                      <span>User Name</span>
                      <h4>{profileData?.username}</h4>
                    </div>
                  </div>
                  <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                    <div class="user-info">
                      <span>Contact Person</span>
                      <h4>{profileData?.contact_person}</h4>
                    </div>
                  </div>
                  <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                    <div class="user-info">
                      <span>Email Id</span>
                      <h4>{profileData?.email}</h4>
                    </div>
                  </div>
                  <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                    <div class="user-info">
                      <span>Mobile Number</span>
                      <h4>{profileData?.phone}</h4>
                    </div>
                  </div>
                  <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                    <div class="user-info">
                      <span>Company Name</span>
                      <h4>{profileData?.company_name}</h4>
                    </div>
                  </div>
                  <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                    <div class="user-info">
                      <span>Address</span>
                      <h4>{profileData?.address}</h4>
                    </div>
                  </div>
                  <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                    <div class="user-info">
                      <span>Country</span>
                      <h4>{profileData?.country}</h4>
                    </div>
                  </div>
                  <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                    <div class="user-info">
                      <span>Pricing</span>
                      <h4>
                        {profileData?.pricing_model === 0
                          ? "Fixed"
                          : profileData?.pricing_model === 1
                          ? "Revenue Sharing"
                          : profileData?.pricing_model === 2
                          ? "Both"
                          : profileData?.pricing_model}
                      </h4>
                    </div>
                  </div>
                  {
                    profileData?.pricing_model === 0 ?                  
                  <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                    <div class="user-info">
                      <span>Fixed Fee</span>
                      <h4>{profileData?.fixed_fee} Rs</h4>
                    </div>
                  </div> : null
                  }
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfilePage;
